import { Pipe, PipeTransform } from '@angular/core'
import { ConjugationPipe } from '../../../shared/pipes/core/conjugation.pipe'
import { NounsInterface } from '../../../shared/pipes/core/nouns.interface'

@Pipe({ name: 'displayCountTenants' })
export class DisplayCountTenantsPipe extends ConjugationPipe implements PipeTransform {

    transform(subjects: Array<Object>, nouns?: NounsInterface, always?: boolean): string {
        return super.transform(subjects, {fiveOrMore: 'pachtýřů', twoToFour: 'pachtýři', one: 'pachtýř'}, always)
    }
}
